import React, { Component, useEffect } from 'react';
import * as Progress    from 'react-native-progress';
import * as ImagePicker from 'expo-image-picker';
import LottieView       from 'lottie-react-native';
import { SafeAreaView, StyleSheet, View, Platform, Image, TouchableOpacity } from 'react-native';
import { Button, Input, Routes, Icon, MediaModal, Screen, Cards, Line, Text, Colors } from '../components';
import { HomePetsList, MyAccountCards, HomeMyAccountSection, HomeActiveChats, HomeUpcomingAppointments, ArticlesSection, ArticlesHeroSection } from '../containers';
import { DateUtils, EventsUtils }  from '../utils';
import AuthController from '../controllers/authController';
import PetController from '../controllers/petController';
import ConsultationController from '../controllers/consultationController';
import UtilitiesController    from '../controllers/utilitiesController';
import UserController         from '../controllers/userController';
import MediaController        from '../controllers/mediaController';
import { useNavigate, useLocation } from 'react-router-dom';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Video }  from 'expo-av';
import * as Linking from "expo-linking";

class HomeScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: {},
      upload_object: null,
      pets: [],
      expand_user_menu: false,
      expand_sign_in: false,
      article_sections: [],
      hero_articles: [],
      initialized: false,
      data_loaded: false,
      signed_in: false,
      seconds_elapsed: 0,
      loading_articles: false
    }
  }

  handleOpenURL = async ({ url }) => {
    try {
      const { hostname, path } = Linking.parse(url);
      this.props.navigation.push(`/${hostname}`, { article_id: path});
    } catch (err) {
      console.log(err);
    }
  }

  async componentDidMount() {

    this.refresh_screen_data('auth');
    this.refresh_screen_data('articles');
    this.refresh_screen_data('consultations');
    this.refresh_screen_data('notifications');

    await AuthController.getPartnerDetails();

    if (Platform.OS !== 'web') {
      // https://reactnative.dev/docs/linking#handling-deep-links
      // Handles linking when app is freshly opened
      Linking.getInitialURL().then(async (url) => {
        try{
          const { hostname, path } = Linking.parse(url);
          if (hostname && path && !this.state.initialized) {
            this.setState({ initialized: true })
            this.props.navigation.push(`/${hostname}`, { article_id: path});
          }
        } catch (err) { console.log(err) }
      })

      // Handles linking when app is running in background
      Linking.addEventListener("url", this.handleOpenURL);
    }

    if (Platform.OS !== 'web') {
      this.props.navigation.addListener('focus', async () => {
        this.refresh_screen_data('auth');
        this.refresh_screen_data('articles');
        this.refresh_screen_data('consultations');
        this.refresh_screen_data('notifications');
        await AuthController.getPartnerDetails();
      });
    }

    EventsUtils.log_facebook_event('PageView')

    this.setState({ data_loaded: true });
  }

  componentWillUnmount() {
    try {
      Linking.removeEventListener("url", this.handleOpenURL);
    } catch(err) {
      console.log('error removing listener', err)
    }
  }

  componentDidUpdate = async () => {
    let is_mobile_app = Platform.OS == 'android' || Platform.OS === 'ios';
    if (is_mobile_app && this.props.notification_data && this.props.notification_data.notification_type && this.props.clear_notification_data) {
      this.handle_notification_navigation(this.props.notification_data);
      this.props.clear_notification_data();
    }
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  render_start_consutlation_btn = () => {
    return <View style={styles.consult_btn_container}>
      <Button title='Talk to a Vet Pro'
              style={{  }}
              icon='user-md'
              onPress={ async () => {
                  await AsyncStorage.setItem('start_consultation_state', '');
                  this.props.navigate(Routes.CONSULTATION_START_FLOW)
              }} />
    </View>
  }

  render_articles = () => {
    let is_web       = Platform.OS === 'web';

    if (is_web) {
      return null;
    }

    let sections     = this.state.article_sections || [];
    let section_rows = sections.map((section, i) => {
      return <View>
        <ArticlesSection
          section={section}
          pressed_action={ (article_nav_data) => {
            if(Platform.OS === 'web') {
              let article_url = article_nav_data && article_nav_data.article && article_nav_data.article.url ? article_nav_data.article.url : '';
              window.open(article_url, '_blank');
            } else {
              this.props.navigation.push(Routes.ARTICLE_DISPLAY, article_nav_data);
            }
          }}
        />
      </View>
    })

    return <View>
      { section_rows }
    </View>
  }

  render_cards = () => {
    let hero_articles = this.state.hero_articles || [];
    let is_web        = Platform.OS === 'web';

    if (is_web) {
      return <View style={{ padding: 20, paddingBottom: 0, marginBottom: 5 }}>
        <Image style={{ height: 220, width: 150, alignSelf: 'center', marginTop: -5, marginBottom: 15 }} source={ require('../assets/images/dodovet-web-hero.png') } />
        <Text style={{ fontSize: 15, color: 'grey' }}>Online pet care available whenever you need it. Start a chat or schedule a video call with a vet pro.</Text>
      </View>;
    }

    return <View>
      <ArticlesHeroSection articles={hero_articles}
                           pressed_action={ (article_nav_data) => {
                             if(Platform.OS === 'web') {
                               let article_url = article_nav_data && article_nav_data.article && article_nav_data.article.url ? article_nav_data.article.url : '';
                               window.open(article_url, '_blank');
                             } else {
                               this.props.navigation.push(Routes.ARTICLE_DISPLAY, article_nav_data);
                             }
                           }}/>
    </View>
  }

  render_active_consultations = () => {
    let chat_array   = this.state.active_chats;
    let appointments = this.state.upcoming_appointments;
    let num_of_chats = chat_array   && chat_array.length   ? chat_array.length   : 0;
    let num_of_appts = appointments && appointments.length ? appointments.length : 0;

    if (!num_of_chats && !num_of_appts) {
      return null;
    }

    return <View style={{ marginBottom: 15 }}>
      <HomeActiveChats navigation={this.props.navigation} user={this.state.user} consultations={ chat_array } hide={ num_of_chats === 0 } />
      <HomeUpcomingAppointments navigation={this.props.navigation} consultations={ appointments } hide={ num_of_appts === 0 } />
    </View>
  }

  render_add_pets_section = () => {
    let display_section = this.state.data_loaded && (this.state.user && !this.state.user.token);
    let is_mobile       = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;

    if (!display_section || !is_mobile) {
      return null;
    }

    return <View style={{ marginTop: 15, paddingLeft: 20, paddingRight: 20 }}>
      <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: 'white', padding: 15, paddingLeft: 5, borderRadius: 10 }}
                        onPress={ () => {
                          this.props.navigate(Routes.PET_LIST);
                        }}>
        <View style={{ marginRight: 10 }}>
          { is_mobile ? <LottieView ref={animation => { this.dog_animation = animation }} style={{ width: 80, height: 80, backgroundColor: 'white', }} source={require('../assets/animations/dog-trot.json')} />
                      : <Image style={{ height: 60, width: 60 }} source={ require('../assets/images/pets-allowed.png') } /> }
        </View>
        <View style={{ flex: 1 }}>
          <Text style={{ fontWeight: '500', fontSize: 18, marginBottom: 2 }}>Add Your Pets</Text>
          <Text style={{ color: 'grey', fontSize: 16 }}>Add your pets to unlock a personalized content feed.</Text>
        </View>
        <View style={{  }}>
          <Icon name='arrow-circle-right' solid={true} size={18} color={ Colors.PRIMARY } />
        </View>
      </TouchableOpacity>
      <Line style={{ marginTop: 15 }} />
    </View>
  }

  render_download_app = () => {
    let is_web = Platform.OS === 'web';

    if (!is_web) {
      return null;
    }

    return <View style={{ marginBottom: 40 }}>
      <Line style={{ marginTop: 20, marginBottom: 20 }}/>
      <View style={{ padding: 20, paddingTop: 0, paddingBottom: 0 }}>
        <Image style={{ height: 75, width: 75, alignSelf: 'center', marginBottom: 10 }} resizeMode='contain' source={ require('../assets/images/dodovet-qr-code.png') } />
        <Text style={{ fontSize: 20, fontWeight: '500', marginBottom: 10, textAlign: 'center' }}>Get the app for FREE Resources</Text>
        <Text style={{ fontSize: 15, color: 'grey', marginBottom: 20 }}>Unlock additional features by downloading the DodoVet app on your iOS or Android device</Text>
        <View style={{ alignItems: 'flex-start' }}>
          <Text style={{ fontSize: 15, color: 'grey' }}><span style={{ marginRight: 2 }}>•</span> Personalized pet care articles.</Text>
          <Text style={{ fontSize: 15, color: 'grey' }}><span style={{ marginRight: 2 }}>•</span> Exclusive content.</Text>
          <Text style={{ fontSize: 15, color: 'grey' }}><span style={{ marginRight: 2 }}>•</span> Resources for every type of pet (and parent!)</Text>
          <Text style={{ fontSize: 15, color: 'grey' }}><span style={{ marginRight: 2 }}>•</span> Access to your completed consults.</Text>
          <Text style={{ fontSize: 15, color: 'grey' }}><span style={{ marginRight: 2 }}>•</span> Revisit the same pro…whenever you need!</Text>
        </View>
        <View style={{ flexDirection: 'row', paddingTop: 25, justifyContent: 'center' }}>
          <View style={{ width: 5 }}></View>
          <TouchableOpacity onPress={ () => {
                              Linking.openURL('https://apps.apple.com/us/app/dodovet/id1616028009')
                            }}>
            <Image style={{ height: 50, width: 140 }} resizeMode='contain' source={ 'https://teletailstest.s3.amazonaws.com/profile/1578674518619.png' } />
          </TouchableOpacity>
          <View style={{ width: 5 }}></View>
          <TouchableOpacity onPress={ () => {
                              Linking.openURL('https://play.google.com/store/apps/details?id=com.teletailscaremobile')
                            }}>
            <Image style={{ height: 50, width: 155 }} resizeMode='contain' source={ 'https://teletailstest.s3.amazonaws.com/profile/1578676143466.png' } />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  }

  render_sign_out = () => {
    let is_web       = Platform.OS === 'web';
    let is_signed_in = this.state.signed_in;
    let email        = this.state.user && this.state.user.email ? this.state.user.email : '';

    if (!is_web || !is_signed_in) {
      return null;
    }

    return <View style={{ marginBottom: 40 }}>

      { this.state.subscription_url ? <Line style={{ marginTop: 20, marginBottom: 20 }}/> : null }
      { this.state.subscription_url ? <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingLeft: 20 }}>
                                        <View>
                                          <Text style={{ fontSize: 20, fontWeight: '500' }}>Subscription</Text>
                                          <Text style={{ fontSize: 14, color: Colors.PRIMARY }}>{ 'Manage subscription' }</Text>
                                        </View>
                                        <Button title='Manage'
                                                style={{ width: 100, fontSize: 12, padding: 0, height: 35, marginRight: 20 }}
                                                onPress={ async () => {
                                                  window.open(this.state.subscription_url)
                                                }} />
                                      </View> : null }

      <Line style={{ marginTop: 20, marginBottom: 20 }}/>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingLeft: 20 }}>
        <View>
          <Text style={{ fontSize: 20, fontWeight: '500' }}>Signed In</Text>
          <Text style={{ fontSize: 14, color: Colors.PRIMARY }}>{ email }</Text>
        </View>
        <Button title='SignOut'
                style={{ width: 100, fontSize: 12, height: 35, marginRight: 20 }}
                onPress={ async () => {
                  await AuthController.signOut();
                  this.refresh_screen_data('auth');
                  this.setState({ active_chats: [], upcoming_appointments: [] });
                }} />
      </View>
    </View>
  }

  refresh_action = async () => {
    this.refresh_screen_data('auth');
    this.refresh_screen_data('articles');
    this.refresh_screen_data('consultations');
    this.refresh_screen_data('notifications');
    await AuthController.getPartnerDetails();
    this.setState({ refresh_loading: false })
  }

  render() {
    return (
      <Screen navigation={this.props.navigation}
              hide_nav_bar={true}
              scroll={true}
              refresh_loading={this.state.refresh_loading}
              refresh_action={ () => {
                this.refresh_action();
                this.setState({ refresh_loading: true });
              }}
              bg_image={true}>
        <HomeMyAccountSection
          navigation={this.props.navigation}
          user={this.state.user}
          expand_menu={this.state.expand_user_menu}
          expand_sign_in={this.state.expand_sign_in}
          display_add_pet={this.state.pets && this.state.pets.length === 0}
          menu_action={ () => {
            this.setState({ expand_user_menu: !this.state.expand_user_menu })
          }}
          profile_action={ () => {
            this.props.navigate(Routes.SETTINGS_USER_PROFILE);
          }}
          sign_in_action={ () => {
            this.setState({ expand_sign_in: !this.state.expand_sign_in })
          }}
          sign_in_success={ async () => {
            let user = await AuthController.getUser(true);
            this.refresh_action();
            this.setState({ expand_sign_in: false, user: user });
          }}
        />

        { this.render_add_pets_section()       }
        { this.render_cards()                  }
        { this.render_start_consutlation_btn() }
        { this.render_active_consultations()   }
        { this.render_articles()               }
        { this.render_download_app()           }
        { this.render_sign_out()               }
      </Screen>
    );
  }

  refresh_screen_data = async (data_category) => {
    let partner_id     = await AsyncStorage.getItem('partner_id');
    let user           = await AuthController.getUser();
    let user_signed_in = user && user.token && user.user_id ? true : false;

    if (data_category === 'auth') {
      let partner_data   = await AuthController.getPartnerDetails();
      let pets_response  = await PetController.getAllPets();
      let pets           = pets_response && pets_response.success  && pets_response.pets ? pets_response.pets : [];
      let sub_manage_url = '';

      if (user_signed_in) {
        let sub_url  = await UserController.getSubscriptionManageUrl({});
        if (sub_url && sub_url.success) {
          let page_url   = sub_url.url;
          let no_sub     = sub_url.no_subscription && sub_url.no_subscription === true ? true : false;
          sub_manage_url = no_sub === true ? '' : page_url;
        }
      }

      this.update_registration();
      this.setState({
        signed_in: user_signed_in,
        user: user,
        data_loaded: true,
        pets: pets,
        active_chats: user_signed_in ? this.state.active_chats : [],
        upcoming_appointments: user_signed_in ? this.state.upcoming_appointments : [],
        subscription_url: sub_manage_url
      });
    }

    if (data_category === 'articles' && !user_signed_in) {
      let articles_response = await UserController.getNewUserArticles();
      let article_sections  = articles_response && articles_response.sections      ?  articles_response.sections      : [];
      let hero_articles     = articles_response && articles_response.hero_articles ?  articles_response.hero_articles : [];

      await AsyncStorage.setItem('user_article_sections', JSON.stringify(article_sections));
      await AsyncStorage.setItem('user_hero_articles',    JSON.stringify(hero_articles));

      this.setState({ article_sections: article_sections, hero_articles: hero_articles, loading_articles: false });
    }

    if (data_category === 'articles' && user_signed_in) {
      let tags_response     = await UserController.refreshUserTags({});
      let articles_response = await UserController.getUserArticles();
      let sections          = articles_response && articles_response.sections      ?  articles_response.sections      : [];
      let hero_articles     = articles_response && articles_response.hero_articles ?  articles_response.hero_articles : [];
      await AsyncStorage.setItem('user_article_sections', JSON.stringify(sections));
      await AsyncStorage.setItem('user_hero_articles',    JSON.stringify(hero_articles));
      this.setState({ article_sections: sections, hero_articles: hero_articles });
    }

    if (data_category === 'consultations' && user_signed_in && partner_id) {
      let chat_consultations    = await ConsultationController.getClientChatConsultations(partner_id);
      let video_consultations   = await ConsultationController.getUpcomingVideoConsultations(partner_id);
      let active_chats          = chat_consultations  && chat_consultations.data  && chat_consultations.data.care_consultations  ? chat_consultations.data.care_consultations  : [];
      let upcoming_appointments = video_consultations && video_consultations.data && video_consultations.data.care_consultations ? video_consultations.data.care_consultations : [];
      this.setState({ active_chats: active_chats, upcoming_appointments: upcoming_appointments, partner_id: partner_id });
    }

    if (data_category === 'notifications' && user_signed_in && (Platform.OS == 'android' || Platform.OS === 'ios')) {
      await UtilitiesController.checkNotifications();
    }
  }

  update_registration = async (partner_details) => {
    let partner_code        = await AsyncStorage.getItem('partner_code');
    let registration_data   = { partner_code: partner_code, status: 'SUBSCRIBED' }
    let update_registration = await UserController.updateUserPartnerRegistration(registration_data);
  }

  non_signed_in_articles = async () => {
    let articles_response = await UserController.getNewUserArticles();
    let article_sections  = articles_response && articles_response.sections      ?  articles_response.sections      : [];
    let hero_articles     = articles_response && articles_response.hero_articles ?  articles_response.hero_articles : [];

    await AsyncStorage.setItem('user_article_sections', JSON.stringify(article_sections));
    await AsyncStorage.setItem('user_hero_articles',    JSON.stringify(hero_articles));

    this.setState({ article_sections: article_sections, hero_articles: hero_articles });
  }

  handle_notification_navigation = (notification_data) => {
    let notification_type = notification_data.notification_type;
        notification_type = notification_type.toLowerCase();

    switch (notification_type) {
      case 'consultation':
        let consultation_type = notification_data.consultation_type || '';
            consultation_type = consultation_type.toLowerCase();
        let consultation_id   = notification_data.consultation_id   || '';

        if (consultation_type && consultation_id && consultation_type === 'video') {
          this.props.navigation.push(Routes.CONSULTATION_VIDEO_APPOINTMENT, { consultation_id: consultation_id });
        }
        if (consultation_type && consultation_id && consultation_type === 'chat') {
          this.props.navigation.push(Routes.CONSULTATION_CHAT, { consultation_id: consultation_id });
        }
        break;
      case 'article':

        break;
      default:

    }
  }

}

const useLocationChange = (action) => {
  const location = useLocation()
  React.useEffect(() => { action(location);  }, [location])
}

function HomeScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();
    let screenRef  = React.createRef();

    useEffect( () => {
      const navToLinkRoute = async () => {
        let link_route = await AsyncStorage.getItem('link_route');

        if(link_route) {
          await AsyncStorage.removeItem('link_route');

          console.log('navigating to push route')
          navigate(link_route);
          console.log('after navigating')
        }
      }

      navToLinkRoute().catch(error => console.log('navToLinkRoute error', error))
    },[]);

    useLocationChange( async (location) => {
      screenRef.refresh_screen_data('auth');
      screenRef.refresh_screen_data('articles');
      screenRef.refresh_screen_data('consultations');
      await AuthController.getPartnerDetails();
    })

    return  <HomeScreen_Base {...props} ref={ node => { screenRef = node }} navigate={navigate} />
  } else {

    //* This hook may be deprecated, not sure though in case it's used by push notifications
    useEffect( () => {
      const navToPushRoute = async () => {
        let link_route = await AsyncStorage.getItem('link_route');
        if(link_route) {
          await AsyncStorage.removeItem('link_route');

          let {route, params} = await UtilitiesController.getLinkPathAndParams(link_route);

          props.navigation.push(`/${route}`, params);
        }
      }

      navToPushRoute().catch(error => console.log('navToPushRoute error', error))
    },[]);

    let home_notification_data  = props.notification_data || {};
    let clear_notification_data = props.clear_notification_data;
    return  <HomeScreen_Base {...props} ref={node=>{screenRef = node}} navigation={props.navigation} navigate={props.navigation.push} notification_data={home_notification_data} clear_notification_data={clear_notification_data} />
  }
}

const styles = StyleSheet.create({
  pets_section_container: {
    padding: 15,
    paddingBottom: 0
  },
  consult_btn_container: {
    padding: 15,
    paddingBottom: 5
  }
});

export default HomeScreen
